/**
 * Whether a category row from GET /api/categories should appear in pickers and rule editors.
 * Treat missing is_active as true (legacy rows).
 */
export function isActiveCategoryApiRow(row: { is_active?: boolean } | null | undefined): boolean {
  if (row == null) return false;
  return row.is_active !== false;
}

/** Selectable catch-all; kept first in Category dropdowns and used as the new-rule default. */
export const UNKNOWN_CATEGORY_NAME = 'Unknown';

export function isUnknownCategoryName(name: string | null | undefined): boolean {
  return (name || '').trim().toLowerCase() === UNKNOWN_CATEGORY_NAME.toLowerCase();
}

/** Sort comparator: Unknown first, then locale name order. */
export function compareCategoryNamesUnknownFirst(
  aName: string | null | undefined,
  bName: string | null | undefined
): number {
  const aUnknown = isUnknownCategoryName(aName);
  const bUnknown = isUnknownCategoryName(bName);
  if (aUnknown !== bUnknown) return aUnknown ? -1 : 1;
  return (aName || '').localeCompare(bName || '', undefined, { sensitivity: 'base' });
}

export function sortCategoriesUnknownFirst<T extends { name: string }>(rows: T[]): T[] {
  return [...rows].sort((a, b) => compareCategoryNamesUnknownFirst(a.name, b.name));
}

/** Prefer Unknown as the default Category select / new-rule target. */
export function defaultCategoryIdUnknownFirst(rows: Array<{ id: number; name: string }>): number {
  const unknown = rows.find((c) => isUnknownCategoryName(c.name));
  if (unknown) return unknown.id;
  return rows[0]?.id ?? 0;
}
